import { PageLayout } from "../components/PageLayout";
import { CodeBases } from "../features/codebases/Codebases";

export const CodebasesPage: React.FC = () => {
  return <PageLayout>
    <CodeBases />
  </PageLayout>;
};